var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalancededucted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34082 0.601562C8.52186 0.385896 8.85791 0.54336 8.83203 0.801758L8.2832 6.13086L8.22656 6.68262H13.2227C13.276 6.68271 13.3285 6.69743 13.373 6.72559C13.4176 6.75378 13.4527 6.79429 13.4746 6.84082C13.4964 6.88726 13.5046 6.93875 13.498 6.98926C13.4915 7.03994 13.47 7.08805 13.4365 7.12793L5.65918 16.3984C5.47813 16.6141 5.14209 16.4566 5.16797 16.1982L5.7168 10.8691L5.77344 10.3174H0.777344C0.723964 10.3173 0.671512 10.3026 0.626953 10.2744C0.582428 10.2462 0.547329 10.2057 0.525391 10.1592C0.503573 10.1127 0.495422 10.0612 0.501953 10.0107C0.508534 9.96006 0.530032 9.91195 0.563477 9.87207L8.34082 0.601562Z",
    stroke: "#FFAC33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalancededucted);
export default __webpack_public_path__ + "static/media/balancededucted.30ca989282247d2d19efc19ad86a9a54.svg";
export { ForwardRef as ReactComponent };